<template>
    <div>
        <!-- Modal Component -->
        <b-modal v-model="openModal" :title="`Subcontractor Status: Section ${section_number}`" size="lg" ok-title="Update Section Status" ok-variant="success" no-fade @hide="handleHide" @hidden="handleHidden" @ok="handleOk" :ok-disabled="saving" ref="subSectionStatusModal" :no-close-on-backdrop="true" scrollable>

            <div v-if="loading" class="text-center">
                <i class="fa fa-circle-o-notch fa-spin"></i> Loading
            </div>
            <div v-else>
                <div class="form-group row">
                    <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.status_id }">
                        Status: <i class="fa fa-asterisk text-danger"></i>
                    </label>
                    <div class="col-md-8">
                        <b-form-select v-model="payload.status_id" :options="statuses" :class="{'is-invalid': errors.status_id }" />

                        <span v-if="errors.status_id" class="text-danger">
                            <span v-for="error in errors.status_id">{{ error }}</span>
                        </span>
                    </div>
                </div>

                <div class="form-group row">
                    <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.comment }">
                        Status Note: <i class="fa fa-asterisk text-danger"></i><br>
                    </label>
                    <div class="col-md-8">
                        <b-form-textarea v-model="payload.comment" :class="{'is-invalid': errors.comment }" :rows="4" :max-row="8" placeholder="Enter Status Comment"></b-form-textarea>

                        <span v-if="errors.comment" class="text-danger">
                            <span v-for="error in errors.comment">{{ error }}</span>
                        </span>
                    </div>
                </div>

                <div class="form-group row">
                    <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.public_comment }">
                        Public Status Note <i class="fa fa-question-circle" title="These comments may be sent to the subcontractor when notifying them of status changes"></i>:<br>
                    </label>
                    <div class="col-md-8">
                        <b-form-textarea v-model="payload.public_comment" :class="{'is-invalid': errors.public_comment }" :rows="4" :max-row="8" placeholder="Enter Public Status Comment"></b-form-textarea>

                        <span v-if="errors.public_comment" class="text-danger">
                            <span v-for="error in errors.public_comment">{{ error }}</span>
                        </span>
                    </div>
                </div>

                <div class="form-group row" v-if="confirmation_required">
                    <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.confirm_status_change }">
                        Confirmation Required:<br>
                    </label>
                    <div class="col-md-8">
                        <div class="alert alert-warning">
                            <b-form-checkbox v-model="payload.confirm_status_change" :value="true" :unchecked-value="false" plain>{{ confirmation_message }}</b-form-checkbox>

                            <span v-if="errors.confirm_status_change" class="text-danger">
                                <span v-for="error in errors.confirm_status_change">{{ error }}</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    export default {
        props: {

            subcontractorId: {
                type: Number,
                default: null,
            },

        },

        data: function() {
            return {
                openModal: false,
                errors: {},
                saving: false,
                loading: true,
                section_number: null,
                statuses: [],
                payload: {
                    status_id: '',
                    comment: '',
                    public_comment: '',
                    confirm_status_change: false,
                },

                confirmation_required: false,
                confirmation_message: null,
            }
        },

        methods: {

            handleHide(bvEvt){

            },

            handleHidden(bvEvt){
                //Reset the errors
                this.errors = {};

                //Reset the values
                this.payload = {
                    status_id: '',
                    comment: '',
                    public_comment: '',
                };
            },

            handleOk: function(bvEvt) {
               //Stops the modal from closing
               bvEvt.preventDefault();

               //Do it
               this.saveStatus();
            },

            setModel(payload){
                this.payload = payload;

                // If we don't find the name, default to empty
                if (this.statuses.filter(e => e.value == payload.status_id).length === 0)
                    this.payload.status_id = '';
            },

            setSection(section_number) {
                this.section_number = section_number;
            },

            showModal(){
                //Open the modal
                this.openModal = true;
            },

            getStatuses(){
                // Yeah it's silly having 2 arrays for statuses, but it's better to load twice than once every time it's opened

                //Get the statuses
                this.$http
                    .get('subcontractors/statuses', {type: 'section'})
                    .then(response => {
                        //Set all the data
                        this.statuses = [{value: '', text: '-- Select a Status --'}];
                        this.statuses = this.statuses.concat(response.data);
                    })
                    .catch(response => {

                    })
                    .then(response => {
                        this.loading = false;
                    });
            },

            saveStatus(){
                this.saving = true;

                let data = this.payload;
                data.section_number = this.section_number;

                //Send it
                this.$http
                .post('subcontractors/status/' + this.subcontractorId, data)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Subcontractor Section Status Updated');

                    //Emit ?
                    this.$emit('sectionStatusChanged', response.data);

                    //Close the modal
                    this.$refs.subSectionStatusModal.hide();

                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                    else if(error.response && error.response.status == 451)
                    {
                        //Set the message
                        this.confirmation_required = true;
                        this.confirmation_message = error.response.data;

                        //Alert the user
                        this.$toastr.error(error.response.data);
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            }
        },

        mounted() {
            //SEt the height
            //this.$refs.subSectionStatusModal.$refs.body.style['max-height'] = window.innerHeight * 0.75 + 'px';

            this.getStatuses();
        }
    }
</script>